import React from 'react';

function escapeRegex(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function Mark({ children }: { children: React.ReactNode }) {
  return <mark className="bg-transparent text-inherit">{children}</mark>;
}

// Highlight matches in a label against the user's query. Handles two cases:
//   1. The string already contains <mark>…</mark> tags (e.g., Fumadocs search
//      returns server-side highlights). Convert those to real <mark> elements.
//   2. Plain text — find case-insensitive substring matches of the query tokens
//      and wrap them in <mark>.
//
// Always XSS-safe: we never use dangerouslySetInnerHTML. Unknown HTML is stripped.
export function renderWithHighlight(raw: string, query?: string): React.ReactNode {
  if (raw.includes('<mark>')) {
    const parts = raw.split(/(<mark>.*?<\/mark>)/g);
    return parts.map((part, i) => {
      const match = part.match(/^<mark>(.*?)<\/mark>$/);
      if (match) return <Mark key={i}>{match[1]}</Mark>;
      return part.replace(/<[^>]+>/g, '');
    });
  }

  const safe = raw.replace(/<[^>]+>/g, '');
  if (!query || query.trim().length < 2) return safe;

  const tokens = query.trim().split(/\s+/).filter(Boolean).map(escapeRegex);
  if (tokens.length === 0) return safe;
  const pattern = new RegExp(`(${tokens.join('|')})`, 'gi');
  const parts = safe.split(pattern);
  return parts.map((part, i) => (i % 2 === 1 ? <Mark key={i}>{part}</Mark> : part));
}
